
window.hj = window.hj || function (){
	(hj.q = hj.q || []).push(arguments);
};



// WEBPACK FOOTER //
// ./client/src/core/components/hotjar/hotjar-tracker.js